import { render, staticRenderFns } from "./ImageShade.vue?vue&type=template&id=78330d68&scoped=true&"
import script from "./ImageShade.vue?vue&type=script&lang=js&"
export * from "./ImageShade.vue?vue&type=script&lang=js&"
import style0 from "./ImageShade.vue?vue&type=style&index=0&id=78330d68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78330d68",
  null
  
)

export default component.exports